import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  display: flex;
  flex-flow: column;
  border-radius: ${Spacing.S};
  padding: ${Spacing.L};
  background-color: ${Colors.Indigo10};
  gap: ${Spacing.S};
`

export const TextContainer = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${Spacing.XS};
`

export const Header = styled.div`
  display: flex;
  gap: ${Spacing.XS};
  align-items: center;
  ${Typography.S};
  ${FontWeights.DemiBold};
  color: ${Colors.Indigo80};
`

export const Description = styled.div`
  color: ${Colors.Neutral60};
`

export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${Spacing.S};
`
